import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router";
import SwitchAccess from "./SwitchAccess";
import ProfileActions from "./ProfileActions";
import { userServices } from "../Services/userServices";
import { Button, Collapse, Form, ListGroup } from "react-bootstrap";
import { AiOutlineFundProjectionScreen } from "react-icons/ai";
const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

let role = JSON.parse(localStorage.getItem("role"));
let studyStatusData = JSON.parse(localStorage.getItem("studyStatus"));
const clientLabel = JSON.parse(localStorage.getItem("clientLabel"));
const projectLabel = JSON.parse(localStorage.getItem("projectLabel"));
const previousRole = JSON.parse(localStorage.getItem("previousRole"));

const Navbar = ({ setOpenModule, setShowSidebar, handleAddNewTab }) => {
  const { studyId } = useParams();
  const currentURL = window.location.href;
  const splitURL = currentURL.split("/");

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [managementRole, setManagementRole] = useState("");
  const [image, setImage] = useState("");

  const AppsRef = useRef(null);
  const [AppsActive, setAppsActive] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (AppsRef.current && !AppsRef.current.contains(event.target)) {
        setAppsActive(false);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  const getGMTOffset = () => {
    const offsetMinutes = new Date().getTimezoneOffset();
    const sign = offsetMinutes <= 0 ? '+' : '-';
    const absMinutes = Math.abs(offsetMinutes);
    const hours = String(Math.floor(absMinutes / 60)).padStart(2, '0');
    const minutes = String(absMinutes % 60).padStart(2, '0');
    return `GMT${sign}${hours}:${minutes}`;
  }

  useEffect(() => {
    profileData();
  }, []);

  const profileData = async () => {
    const item1 = JSON.parse(localStorage.getItem("firstName"));
    const item2 = JSON.parse(localStorage.getItem("lastName"));
    if (item1) {
      setFirstName(item1);
    }
    if (item2) {
      setLastName(item2);
    }
  };

  let permission = JSON.parse(localStorage.getItem("permissionData"));
  const loginType = JSON.parse(localStorage.getItem("loginType"));
  const studyLogout = JSON.parse(localStorage.getItem("role"));
  const studyManagement = JSON.parse(localStorage.getItem("studyManagement"));
  const etmfStudyManagement = JSON.parse(
    localStorage.getItem("etmfStudyManagement")
  );

  const logout = async () => {
    await userServices.logout();
  };

  useEffect(() => {
    const currentDetails = async (e) => {
      let userData = await userServices.getCurrentUserDetails(e);
      setManagementRole(userData?.[1]?.management_name?.name);
      setImage(userData?.[0]?.user_id?.image);
    };
    currentDetails();
  }, [studyId]);

  return (
    <>
      <div style={{ background: "var(--blue)" }}>
        <div className="hstack justify-content-between border-bottom border-secondary px-2 py-1">
          <h4 className="text-white m-0">Galax®</h4>
          {/* <img src={MainLogo} alt="Company Logo" style={{height: 29}} /> */}
          <div className="hstack justify-content-between gap-2">
            <span className="text-white"><i className="fa-solid fa-earth-asia me-1 text-info"></i>Timezone: {getGMTOffset() || "NA"}</span>
            <span className="text-white"><i className="fa-solid fa-building-user me-1 text-info"></i>Logged in as :{" "}
              {studyLogout === "client"
                ? "Admin"
                : studyLogout === "user"
                  ? managementRole
                  : splitURL[3] === "etmf"
                    ? etmfStudyManagement
                    : studyManagement}
            </span>
            <div className="hstack gap-1">
              <ProfileActions
                handleAddNewTab={handleAddNewTab}
                ProfileImage={image}
                firstName={firstName}
                lastName={lastName}
              />
              {loginType !== "direct" && !(studyLogout === "client" ||
                studyLogout === "user" ||
                studyLogout === "super_user") && (
                <SwitchAccess 
                  clientLabel={clientLabel}
                  projectLabel={projectLabel}
                  StudyMode={StudyMode}
                />
              )}
              <Button
                onClick={logout}
                variant="outline-danger"
                className="p-1 px-2 border-0 br3"
                style={{ fontSize: 13 }}
                title="Sign out from panel"
              >
                <i className="fa-solid fa-right-from-bracket me-1"></i>Signout
              </Button>
            </div>
          </div>
        </div>
        <div className="hstack justify-content-between filebar" style={{ height: 35, padding: 5 }}>
          {/* App Section  */}
          <div ref={AppsRef}>
            {(role === "user" || role === "client") &&
              <Button className="position-relative border-0 py-1 px-2 text-start" variant="outline-light" onClick={() => setAppsActive(!AppsActive)}>
                <div className="hstack gap-1" style={{fontSize: 12}}>
                  <i className="fa-solid fa-grip me-1 text-info"></i>
                  <p className="m-0">Apps</p>
                  <i className={`fa-solid fa-angle-${AppsActive ? "up" : "down"}`}></i>
                </div>
                <Collapse in={AppsActive === true}>
                  <div className="position-absolute start-0" style={{ top: 31, zIndex: 999 }}>
                    <ListGroup style={{ fontSize: 12, width: "max-content" }}>
                      <ListGroup.Item action onClick={() => { setOpenModule("clients"); setShowSidebar(true) }} title="Clients Management">
                        <i className={`fa-solid fa-building-user me-2`}></i>Clients Management
                      </ListGroup.Item>
                      {(role === "client" || permission?.userManagementAccess) &&
                        <ListGroup.Item action onClick={() => { setOpenModule("users"); setShowSidebar(true) }} title="Users Management">
                          <i className={`fa-solid fa-users me-2`}></i>Users Management
                        </ListGroup.Item>
                      }
                      {(permission?.globalFormManagementAccess) && 
                        <ListGroup.Item action onClick={() => { setOpenModule("globalLibrary"); setShowSidebar(true) }} title="Global Form Library">
                          <i className={`fa-solid fa-building-lock me-2`}></i>Global Form Library
                        </ListGroup.Item>
                      }
                      {(permission?.etmfFormManagementAccess) && 
                        <ListGroup.Item action onClick={() => { setOpenModule("etmf"); setShowSidebar(true) }} title="eTMF Management">
                          <i className={`fa-solid fa-book-open me-2`}></i>eTMF Management
                        </ListGroup.Item>
                      }
                      {(permission?.cdiscManagementAccess) && 
                        <ListGroup.Item action onClick={() => { setOpenModule("cdisc"); setShowSidebar(true) }} title="CDISC Management">
                          <i className={`fa-solid fa-database me-2`}></i>CDISC Management
                        </ListGroup.Item>
                      }
                      {/* <ListGroup.Item action onClick={() => { setOpenModule("rbqm"); setShowSidebar(true) }}>
                        <i className={`fa-solid fa-shield me-2`}></i>RBQM
                      </ListGroup.Item> */}
                      {(permission?.queryManagementAccess) && 
                        <ListGroup.Item action onClick={() => { setOpenModule("studyQueryMetadata"); setShowSidebar(true) }} title="Study Query Metadata">
                          <i className={`fa-solid fa-comment me-2`}></i>Study Query Metadata
                        </ListGroup.Item>
                      }
                      <ListGroup.Item action onClick={() => { setOpenModule("logs"); setShowSidebar(true) }} title="Logs Management">
                        <i className={`fa-solid fa-clock-rotate-left me-2`}></i>Logs Management
                      </ListGroup.Item>
                    </ListGroup>
                  </div>
                </Collapse>
              </Button>
            }
            {(role === "LUP") &&
              <Button className="position-relative border-0 py-1 px-2 text-start" variant="outline-light" onClick={() => setAppsActive(!AppsActive)}>
                <div className="hstack gap-1" style={{fontSize: 12}}>
                  <i className="fa-solid fa-grip me-1 text-info"></i>
                  <p className="m-0">Menu</p>
                  <i className={`fa-solid fa-angle-${AppsActive ? "up" : "down"}`}></i>
                </div>
                <Collapse in={AppsActive === true}>
                  <div className="position-absolute start-0" style={{ top: 31, zIndex: 999 }}>
                    <ListGroup style={{ fontSize: 12, width: "max-content" }}>
                      <ListGroup.Item action onClick={() => { setOpenModule("lupStudy"); setShowSidebar(true) }} title="Study Management">
                        <i className={`fa-solid fa-folder me-2`}></i>Study Management
                      </ListGroup.Item>
                      <ListGroup.Item action onClick={() => { setOpenModule("lupProject"); setShowSidebar(true) }} title="Project Management">
                        <AiOutlineFundProjectionScreen className="me-1" style={{width: 17, height: 17}}/>Project Management
                      </ListGroup.Item>
                      <ListGroup.Item action onClick={() => { setOpenModule("lupPackage"); setShowSidebar(true) }} title="Package Management">
                        <i className={`fa-solid fa-cube me-2`}></i>Package Management
                      </ListGroup.Item>
                      <ListGroup.Item action onClick={() => { setOpenModule("lupFile"); setShowSidebar(true) }} title="File Management">
                        <i className={`fa-solid fa-desktop me-2`}></i>File Management
                      </ListGroup.Item>
                    </ListGroup>
                  </div>
                </Collapse>
              </Button>
            }
            {(role === "cdisc") &&
              <Button className="position-relative border-0 py-1 px-2 text-start" variant="outline-light" onClick={() => setAppsActive(!AppsActive)}>
                <div className="hstack gap-1" style={{fontSize: 12}}>
                  <i className="fa-solid fa-grip me-1 text-info"></i>
                  <p className="m-0">Menu</p>
                  <i className={`fa-solid fa-angle-${AppsActive ? "up" : "down"}`}></i>
                </div>
                <Collapse in={AppsActive === true}>
                  <div className="position-absolute start-0" style={{ top: 31, zIndex: 999 }}>
                    <ListGroup style={{ fontSize: 12, width: "max-content" }}>
                      <ListGroup.Item action onClick={() => { setOpenModule("cdiscStudy"); setShowSidebar(true) }} title="Study Management">
                        <i className={`fa-solid fa-folder me-2`}></i>Study Management
                      </ListGroup.Item>
                      <ListGroup.Item action onClick={() => { setOpenModule("cdiscMetadata"); setShowSidebar(true) }} title="Metadata Management">
                        <i className={`fa-solid fa-list me-2`}></i>Metadata Management
                      </ListGroup.Item>
                      <ListGroup.Item action onClick={() => { setOpenModule("cdiscRunOutput"); setShowSidebar(true) }} title="Run / Output">
                        <i className={`fa-solid fa-play me-2`}></i>Run / Output
                      </ListGroup.Item>
                    </ListGroup>
                  </div>
                </Collapse>
              </Button>
            }
          </div>
          {/* Study Details  */}
          {StudyMode && (
            <div className={`justify-content-between hstack gap-3`}>
              <Form.Label className="m-0 hstack gap-1">
                <i className="fa-solid fa-user-tie live__mode__color" />
                <span className="text-white client1">{clientLabel}</span>
              </Form.Label>

              <Form.Label className="m-0 hstack gap-1">
                <i className="fa-solid fa-folder-open live__mode__color" />
                <span className="text-white projectid">{projectLabel}</span>
              </Form.Label>
              <Form.Label className="m-0">
                {(role !== "user" || role !== "client") && (
                  <div className="hstack gap-1">
                    <div>
                      <i className={(StudyMode === "DBP Mode" || StudyMode === "DV Mode") ? "fa-solid fa-circle dbp__mode__color" : ""} />
                      <i className={(StudyMode === "Production Mode" || StudyMode === "SDV Live Mode" || StudyMode === "Read Only Live Mode" || StudyMode === "Live Mode") ? "fa-solid fa-circle live__mode__color" : ""} />
                      <i className={(StudyMode === "SDV QC Mode" || StudyMode === "QC Mode") ? "fa-solid fa-circle qc__mode__color" : ""} />
                    </div>
                    <span className="text-white projectid"> {StudyMode}</span>
                  </div>
                )}
              </Form.Label>
              <Form.Label className="m-0 hstack gap-1">
                <i className="fa-solid fa-folder live__mode__color" />
                <span className="text-white projectid capitalize">Status : {studyStatusData}</span>
              </Form.Label>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Navbar;
